module.exports = __webpack_public_path__ + "static/media/OTF.b9321b0a.svg";